export const colorPrincipal = "#001F54"
export const colorFluerecente = "#34D3F3"
export const colorOscuro = "#020230"
export const colorClaro = "#F5F8FA"
export const colorBorde = "#DADADA"
export const fuentePrincipal = "'Poppins', system-ui"
export const fuenteTitulos = "'Roboto', system-ui"
export const cmsURL = "http://localhost:1337"
